<script>
    
    import '../$styles/dark.scss'
    import { userStore, modalStore } from '../stores'

</script>

<div class="title">Información personal</div>

<div class="columns">
    <div class="column">
        <label for="" class="label">Nombre(s)</label>
        { $userStore.firstName }
    </div>
    <div class="column">
        <label for="" class="label">Apellido(s)</label>
        { $userStore.lastName || 'Sin información' }
    </div>
</div>
<div class="columns">
    <div class="column">
        <label for="" class="label">Corporación</label>
        { $userStore.corporate || 'Sin información' }
    </div>
    <div class="column">
        <label for="" class="label">Teléfono</label>
        { $userStore.phone }
    </div>
</div>
<div class="items-end">
    <button on:click={() => modalStore.set('user_update_modal') } class="button">
        <span class="icon"><i class="fas fa-edit"></i></span>
        <span>Editar</span>
    </button>
</div>
{#if $userStore.adviser && $userStore.adviser.email}
    <div class="is-divider"></div>
    <div class="columns">
        <div class="column">
            <label for="" class="label">Asesor</label>
            { $userStore.adviser.name }
        </div>
        <div class="column">
            <label for="" class="label">Teléfono</label>
            { $userStore.adviser.phone }
        </div>
    </div> 
    <div class="columns">
        <div class="column">
            <label for="" class="label">Correo</label>
            { $userStore.adviser.email }
        </div>
    </div> 
{/if}
